import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// import { EventsComponent } from './events/events.component';
import { RouteParamName } from './shared/enums';

const routes: Routes = [
    {
        path: 'events',
        loadComponent: () => import('./events-access/events-access.component'),
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    },
    {
        path: `events/:${RouteParamName.eventId}`,
        loadChildren: () => import('./event/event.module').then(x => x.EventModule)
    },
    // {
    //     path: 'events/:id/participants',
    //     component: EventParticipantsComponent
    // },
    // {
    //     path: 'events/:id/activities',
    //     component: EventActivitiesComponent
    // },
    // {
    //     path: 'events/:id/activities/:activityId/participants',
    //     component: EventActivityParticipantsComponent
    // },
    {
        path: '',
        redirectTo: 'events',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: 'events',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            routes,
            {
    paramsInheritanceStrategy: 'always'
}
        )
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
